module.exports = __webpack_public_path__ + "static/media/films.c4730636.jpg";